import * as RouteUrls from './RouteConstants';

const routeHelpTabConfig = [
  {
    route: RouteUrls.SEARCH_CHECK,
    helperId: '2056',
  },
  {
    route: RouteUrls.SEARCH_CHECK_DETAIL,
    helperId: '2056',
  },
  {
    route: RouteUrls.MAINTAIN_CLIENT,
    helperId: '2057',
  },
  {
    route: RouteUrls.TBILL_RATES,
    helperId: '2072',
  },
  {
    route: RouteUrls.DRUG_FAMILY,
    helperId: '2059',
  },
  {
    route: RouteUrls.DRUG_FAMILY_DETAIL,
    helperId: '2059',
  },
  {
    route: RouteUrls.UNIT_CONVERSION,
    helperId: '2073',
  },
  {
    route: RouteUrls.UNIT_CONVERSION_DETAIL,
    helperId: '2073',
  },

  {
    route: RouteUrls.MANUFACTURER,
    helperId: '2065',
  },
  {
    route: RouteUrls.MANUFACTURER_DETAIL,
    helperId: '2065',
  },
  {
    route: RouteUrls.EXCLUDE_NDC,
    helperId: '2060',
  },
  {
    route: RouteUrls.EXCLUDE_NDC_DETAIL,
    helperId: '2060',
  },
  {
    route: RouteUrls.CHECK,
    helperId: '2056',
  },
  {
    route: RouteUrls.CHECK_DETAIL,
    helperId: '2056',
  },
  {
    route: RouteUrls.REQUEST_CLAIM_AUDIT,
    helperId: '2076',
  },
  {
    route: RouteUrls.LOG_BATCH_TOTAL,
    helperId: '2162',
  },
  {
    route: RouteUrls.LOG_BATCH_TOTAL_DETAIL,
    helperId: '2162',
  },
  {
    route: RouteUrls.ASSIGN_DISPUTES,
    helperId: '2155',
  },
  {
    route: RouteUrls.ASSIGN_DISPUTES_DETAIL,
    helperId: '2155',
  },
  {
    route: RouteUrls.VIEW_CHECKS_BY_ASSOCIATED_INVOICES,
    helperId: '2170',
  },
  {
    route: RouteUrls.LOG_CHECK,
    helperId: '2163',
  },
  {
    route: RouteUrls.COMMENT_AND_CORRESPONDENCE,
    helperId: '2141',
  },
  {
    route: RouteUrls.REQUEST_MAILING_LABELS,
    helperId: '2167',
  },
  {
    route: RouteUrls.LABELER_DIFFERENCES,
    helperId: '2083',
  },
  {
    route: RouteUrls.INVOICE_AUDITS,
    helperId: '2224',
  },
  {
    route: RouteUrls.INVOICE_AUDITS_DETAIL,
    helperId: '2224',
  },
  {
    route: RouteUrls.CMS_MISMATCH,
    helperId: '2078',
  },
  {
    route: RouteUrls.CMS_MISMATCH_DETAIL,
    helperId: '2078',
  },
  {
    route: RouteUrls.LINK_NEW_DRUG_TO_DRUG_FAMILY,
    helperId: '2160',
  },
  {
    route: RouteUrls.CALCULATE_INTEREST,
    helperId: '2156',
  },
  {
    route: RouteUrls.LETTER_TEMPLATE,
    helperId: '2064',
  },
  {
    route: RouteUrls.LETTER_TEMPLATE_DETAIL,
    helperId: '2064',
  },
  {
    route: RouteUrls.VIEW_CHECK_ALLOCATIONS,
    helperId: '2169',
  },
  {
    route: RouteUrls.VIEW_CHECK_ALLOCATIONS_DETAIL,
    helperId: '2169',
  },
  {
    route: RouteUrls.CMS_ROSI_DISCREPANCIES,
    helperId: '2079',
  },
  {
    route: RouteUrls.CMS_ROSI_DISCREPANCIES_DETAIL,
    helperId: '2079',
  },
  {
    route: RouteUrls.DISPUTES,
    helperId: '2081',
  },
  {
    route: RouteUrls.CLAIM_AUDITS,
    helperId: '2076',
  },
  {
    route: RouteUrls.CLAIM_AUDITS_DETAIL,
    helperId: '2076',
  },
  {
    route: RouteUrls.CMS_DRUG_FILE_DISCREPANCIES,
    helperId: '2077',
  },
  {
    route: RouteUrls.CMS_DRUG_FILE_DISCREPANCIES_DETAIL,
    helperId: '2077',
  },
  {
    route: RouteUrls.CONTRACT,
    helperId: '2058',
  },
  {
    route: RouteUrls.CONTRACT_DETAIL,
    helperId: '2058',
  },
  {
    route: RouteUrls.UNDER_THRESHOLD_INVOICES,
    helperId: '2085',
  },
  {
    route: RouteUrls.UNDER_THRESHOLD_INVOICES_DETAIL,
    helperId: '2085',
  },
  {
    route: RouteUrls.SUSPENDED_CHECKS,
    helperId: '2074',
  },
  {
    route: RouteUrls.ROSI_PQAS_INCONSISTENCIES,
    helperId: '2084',
  },
  {
    route: RouteUrls.ROSI_PQAS_INCONSISTENCIES_DETAIL,
    helperId: '2084',
  },
  {
    route: RouteUrls.CONTACT_ANOMALIES,
    helperId: '2080',
  },
  {
    route: RouteUrls.REBATE_PRICE_LEVEL,
    helperId: '2070',
  },
  {
    route: RouteUrls.REBATE_PRICE_LEVEL_DETAIL,
    helperId: '2070',
  },
  {
    route: RouteUrls.REBATE_PROGRAM,
    helperId: '2071',
  },
  {
    route: RouteUrls.REBATE_PROGRAM_DETAIL,
    helperId: '2071',
  },
  {
    route: RouteUrls.REBATE_PROGRAM_CREATE,
    helperId: '2071',
  },
  {
    route: RouteUrls.CREATE_LETTER,
    helperId: '2157',
  },
  {
    route: RouteUrls.CREATE_LETTER_DETAIL,
    helperId: '2157',
  },
  {
    route: RouteUrls.ACCOUNTS_RECEIVABLE,
    helperId: '2075',
  },
  {
    route: RouteUrls.ACCOUNTS_RECEIVABLE_NDC_DETAIL,
    helperId: '2204',
  },
  {
    route: RouteUrls.ACCOUNTS_RECEIVABLE_NDC_ACTIVITY,
    helperId: '2211',
  },
  {
    route: RouteUrls.ACCOUNTS_RECEIVABLE_NDC_DETAIL_ALL,
    helperId: '2204',
  },
  {
    route: RouteUrls.ACCOUNTS_RECEIVABLE_SUBSYSTEM_OVERVIEW,
    helperId: '2205',
  },
  {
    route: RouteUrls.ACCOUNTS_RECEIVABLE_SUMMARY_BY_MANUFACTURER,
    helperId: '2206',
  },
  {
    route: RouteUrls.ACCOUNTS_RECEIVABLE_SUMMARY_BY_MANUFACTURER_ALL,
    helperId: '2206',
  },
  {
    route: RouteUrls.ACCOUNTS_RECEIVABLE_SUMMARY_BY_QUARTER,
    helperId: '2207',
  },
  {
    route: RouteUrls.ACCOUNTS_RECEIVABLE_SUMMARY_BY_QUARTER_ALL,
    helperId: '2207',
  },
  {
    route: RouteUrls.MANUFACTURER_ACCOUNTS_RECEIVABLE,
    helperId: '2209',
  },
  {
    route: RouteUrls.MANUFACTURER_ACCOUNTS_RECEIVABLE_ARM,
    helperId: '2209',
  },
  {
    route: RouteUrls.QUARTERLY_ACCOUNTS_RECEIVABLE,
    helperId: '2210',
  },
  {
    route: RouteUrls.QUARTERLY_ACCOUNTS_RECEIVABLE_ALL,
    helperId: '2210',
  },
  {
    route: RouteUrls.PERFORM_DISPUTE,
    helperId: '2193',
  },
  {
    route: RouteUrls.PERFORM_DISPUTE_DETAIL,
    helperId: '2193',
  },
  {
    route: RouteUrls.PERFORM_DISPUTE_SUMMARY,
    helperId: '2194',
  },
  {
    route: RouteUrls.PERFORM_DISPUTE_CLAIMS_DETAIL,
    helperId: '2191',
  },
  {
    route: RouteUrls.PERFORM_DISPUTE_NDC_HISTORY,
    helperId: '2192',
  },
  {
    route: RouteUrls.REBATE_PRICE_SEARCH,
    helperId: '2069',
  },
  {
    route: RouteUrls.REBATE_PRICE_DETAIL,
    helperId: '2069',
  },
  {
    route: RouteUrls.DISPLAY_LETTER,
    helperId: '2044',
  },
  {
    route: RouteUrls.DISPLAY_LETTER_DETAIL,
    helperId: '2044',
  },
  {
    route: RouteUrls.GENERATE_COLLECTION_LETTER,
    helperId: '2161',
  },
  {
    route: RouteUrls.GENERATE_COLLECTION_LETTER_DETAIL,
    helperId: '2161',
  },
  {
    route: RouteUrls.RECORD_PROVIDER_PREVIEW,
    helperId: '2165',
  },
  {
    route: RouteUrls.RECORD_PROVIDER_PREVIEW_DETAIL,
    helperId: '2165',
  },

  {
    route: RouteUrls.ADD_PREVIOUS_OMITTED_CLAIMS,
    helperId: '2233',
  },
  {
    route: RouteUrls.INVOICE_REPORT,
    helperId: '2043',
  },
  {
    route: RouteUrls.INVOICE_REPORT_DETAILS,
    helperId: '2043',
  },

  {
    route: RouteUrls.PROVIDER,
    helperId: '2046',
  },
  {
    route: RouteUrls.PROVIDER_DETAILS,
    helperId: '2046',
  },
  {
    route: RouteUrls.INVOICE_DETAILS,
    helperId: '2042',
  },
  {
    route: RouteUrls.INVOICE_DETAILS_DISPLAY,
    helperId: '2042',
  },
  {
    route: RouteUrls.NDC,
    helperId: '2045',
  },
  {
    route: RouteUrls.NDC_DETAILS,
    helperId: '2045',
  },
  {
    route: RouteUrls.CLAIM,
    helperId: '2039',
  },
  {
    route: RouteUrls.SELECTED_CLAIM,
    helperId: '2039',
  },
  {
    route: RouteUrls.CHECKS,
    helperId: '2041',
  },
  {
    route: RouteUrls.LETTER,
    helperId: '2044',
  },
  {
    route: RouteUrls.LETTER_DETAILS,
    helperId: '2044',
  },
  {
    route: RouteUrls.URA_SEARCH,
    helperId: '2040',
  },
  {
    route: RouteUrls.URA_SELECTED,
    helperId: '2040',
  },

  {
    route: RouteUrls.DRUG_PRICE_LOAD,
    helperId: '2051',
  },
  {
    route: RouteUrls.DRUG_PRICE_LOAD_DETAILS,
    helperId: '2051',
  },
  {
    route: RouteUrls.REQ_URA_CALCULATION,
    helperId: '2055',
  },
  {
    route: RouteUrls.REQ_INVOICE_CALCULATION,
    helperId: '2049',
  },
  {
    route: RouteUrls.RECORD_MAILING_DATE,
    helperId: '2054',
  },
  {
    route: RouteUrls.FREEZE_INVOICES,
    helperId: '2052',
  },
  {
    route: RouteUrls.GENERATE_INVOICES,
    helperId: '2053',
  },
  {
    route: RouteUrls.GENERATE_INVOICE_DETAILS,
    helperId: '2053',
  },

  {
    route: RouteUrls.MAINTAIN,
    helperId: '2057',
  },
  {
    route: RouteUrls.MAINTAIN_GROUP,
    helperId: '2061',
  },
  {
    route: RouteUrls.GROUP_MAINTAIN,
    helperId: '2061',
  },
  {
    route: RouteUrls.MAINTAIN_PLAN,
    helperId: '2068',
  },
  {
    route: RouteUrls.PLAN,
    helperId: '2068',
  },
  {
    route: RouteUrls.MAINTAIN_INELIGIBLE_PROVIDERS,
    helperId: '2063',
  },
  {
    route: RouteUrls.MAINTAIN_EXCLUDED_NDCS,
    helperId: '2060',
  },
  {
    route: RouteUrls.MAINTAIN_EXCLUDED_NDCS_DETAIL,
    helperId: '2060',
  },
  {
    route: RouteUrls.MAINTAIN_CMS_MAT_DRUGS,
    helperId: '2023',
  },

  {
    route: RouteUrls.MAINTAIN_SYSTEM_PARAMETERS,
    helperId: '2146',
  },
  {
    route: RouteUrls.EXAMINING_PROCEDURE_RESULTS,
    helperId: '2048',
  },
  {
    route: RouteUrls.EXAMINING_PROCEDURE_RESULTS_DETAILS,
    helperId: '2048',
  },
  {
    route: RouteUrls.MAINTAIN_USER_DEFAULTS,
    helperId: '2147',
  },
  {
    route: RouteUrls.MAINTAIN_CODE_TABLES,
    helperId: '2142',
  },
  {
    route: RouteUrls.MAINTAIN_CONTACT_TYPES,
    helperId: '2143',
  },
  {
    route: RouteUrls.MAINTAIN_PRICE_TYPES,
    helperId: '2145',
  },
  {
    route: RouteUrls.QUARTERLY_MARKETING_DATA,
    helperId: '2302',
  },
  {
    route: RouteUrls.QUARTERLY_MARKETING_DATA_DETAILS,
    helperId: '2302',
  },
  {
    route: RouteUrls.PERIODIC_BALANCE_REPORT,
    helperId: '2110',
  },
  {
    route: RouteUrls.TRANSITION_DATA,
    helperId: '2303',
  },
  {
    route: RouteUrls.ONLINE_FIXES,
    helperId: '2300',
  },
  {
    route: RouteUrls.CLAIM_GROUPING_PARAMETERS,
    helperId: '2140',
  },
  {
    route: RouteUrls.CLAIM_GROUPING_PARAMETERS_DETAIL,
    helperId: '2140',
  },
  {
    route: RouteUrls.CREATE_UTILIZATION_TAPE,
    helperId: '2050',
  },
  {
    route: RouteUrls.DISPLAY_CLAIM_DETAIL,
    helperId: '2280',
  },
  {
    route: RouteUrls.VIEW_CALCULATED_INTEREST,
    helperId: '2047',
  },
  {
    route: RouteUrls.VIEW_CALCULATED_INTEREST_DETAILS,
    helperId: '2047',
  },
  {
    route: RouteUrls.USER_LIST,
    helperId: '2154',
  },
  {
    route: RouteUrls.ALLOCATE_PAYMENT_SEARCH,
    helperId: '2176',
  },
  {
    route: RouteUrls.ALLOCATE_PAYMENT_PICK_AN_INVOICE,
    helperId: '2176',
  },
  {
    route: RouteUrls.ALLOCATE_PAYMENT_ROSI_PQAS,
    helperId: '2176',
  },

  //Summary Report
  {
    route: RouteUrls.PAYMENT_SUMMARY_REPORT,
    helperId: '2134',
  },
  {
    route: RouteUrls.REBATE_SUMMARY_REPORT,
    helperId: '2137',
  },
  {
    route: RouteUrls.REBATE_PERCENT_SPEND_REPORT,
    helperId: '2135',
  },
  {
    route: RouteUrls.INVOICE_REGISTER_REPORT,
    helperId: '2133',
  },
  {
    route: RouteUrls.QUARTERLY_PAYMENT_REPORT,
    helperId: '2136',
  },
  {
    route: RouteUrls.INVOICE_QTR_NOT_PAID_REPORT,
    helperId: '2132',
  },
  {
    route: RouteUrls.TOP_BALANCE_REPORT,
    helperId: '2138',
  },
  {
    route: RouteUrls.DRUG_TYPE_SUMMARY_REPORT,
    helperId: '2131',
  },
  {
    route: RouteUrls.DISPUTE_AMOUNT_REPORT,
    helperId: '2128',
  },
  {
    route: RouteUrls.DISPUTE_ACTIVITY_REPORT,
    helperId: '2127',
  },
  {
    route: RouteUrls.DISPUTE_CODE_REPORT,
    helperId: '2129',
  },
  //Detail Report
  {
    route: RouteUrls.UNALLOCATED_BALANCE_REPORT,
    helperId: '2038',
  },
  {
    route: RouteUrls.CHECK_ALLOCATION_COMPARISION_REPORT,
    helperId: '2025',
  },
  {
    route: RouteUrls.CURRENT_ZERO_URA_REPORT,
    helperId: '2027',
  },
  {
    route: RouteUrls.NDC_DETAILS_REPORT,
    helperId: '2034',
  },
  {
    route: RouteUrls.NDC_HISTORY_REPORT,
    helperId: '2035',
  },
  {
    route: RouteUrls.CONTRACT_REPORT,
    helperId: '2026',
  },
  {
    route: RouteUrls.DISPUTE_RECAPITULATION_REPORT,
    helperId: '2028',
  },
  {
    route: RouteUrls.HCPCS_CODE_CLAIMS_PAID_REPORT,
    helperId: '2029',
  },
  {
    route: RouteUrls.INTEREST_OVERRIDE_REPORT,
    helperId: '2030',
  },
  {
    route: RouteUrls.ROSI_PQAS_REPORT,
    helperId: '2037',
  },
  {
    route: RouteUrls.MANUFACTURER_SUMMARY_REPORT,
    helperId: '2031',
  },
  {
    route: RouteUrls.ADJUSTED_CLAIMS_REPORT,
    helperId: '2024',
  },
  {
    route: RouteUrls.MCO_CLAIMS_REPORT,
    helperId: '2032',
  },
  {
    route: RouteUrls.PROVIDER_CLAIMS_LISTING_REPORT,
    helperId: '2036',
  },
  //State Report
  {
    route: RouteUrls.EXCLUDED_CLAIMS_REPORT,
    helperId: '2098',
  },
  {
    route: RouteUrls.CHIP_CSHCN_RATES_REPORT,
    helperId: '2091',
  },
  {
    route: RouteUrls.CHIP_CSHCN_RATES_AUDIT_REPORT,
    helperId: '2092',
  },
  {
    route: RouteUrls.ZERO_URA_REPORT,
    helperId: '2126',
  },
  {
    route: RouteUrls.INTEREST_RECEIVED_REPORT,
    helperId: '2102',
  },
  {
    route: RouteUrls.OUTSTANDING_DISPUTES_AFTER_NUM_OF_DAYS_REPORT,
    helperId: '2108',
  },
  {
    route: RouteUrls.OUTSTANDING_DISPUTES_FOR_QUARTER_REPORT,
    helperId: '2109',
  },
  {
    route: RouteUrls.ADJUSTMENT_BY_REASON_CODE_REPORT,
    helperId: '2089',
  },
  {
    route: RouteUrls.QUARTERLY_CMS_UROA_REPORT,
    helperId: '2117',
  },
  {
    route: RouteUrls.INSTITUTIONAL_CLAIMS_UNIT_TYPE_DISCREPANCY_REPORT,
    helperId: '2101',
  },
  {
    route: RouteUrls.QUARTERLY_CMS_DRUG_REPORT,
    helperId: '2116',
  },
  {
    route: RouteUrls.B_PROVIDER_CLAIMS_REPORT,
    helperId: '2087',
  },
  {
    route: RouteUrls.PROGRAM_ELIGIBILITY_CATEGORY_REPORT,
    helperId: '2114',
  },
  {
    route: RouteUrls.TOTAL_DOLLARS_PAID_REPORT,
    helperId: '2124',
  },
  {
    route: RouteUrls.PRE_INVOICE_UNIT_ADJUSTMENT_REPORT,
    helperId: '2113',
  },
  {
    route: RouteUrls.CURRENT_TO_PREVIOUS_QTR_INVOICE_COMPARIRION_REPORT,
    helperId: '2094',
  },
  {
    route: RouteUrls.CASH_RECEIPT_SUMMARY_REPORT,
    helperId: '2090',
  },
  {
    route: RouteUrls.CMS_ADJUSTMENT_DETAIL_REPORT,
    helperId: '2093',
  },
  {
    route: RouteUrls.OUTSTANDING_BALANCE_BY_LABERER_AND_QUARTER_REPORT,
    helperId: '2107',
  },
  {
    route: RouteUrls.MANUFACTURER_OUTSTANDING_BALANCE_REPORT,
    helperId: '2104',
  },
  {
    route: RouteUrls.NDC_PAYMENT_REPORT,
    helperId: '2106',
  },
  {
    route: RouteUrls.FAMILY_PLANNING_DRUG_INVOICED_REBATES_REPORT,
    helperId: '2099',
  },
  {
    route: RouteUrls.FAMILY_PLANNING_DRUGS_PAYMENT_RECEIVED_REPORT,
    helperId: '2100',
  },
  {
    route: RouteUrls.ACTIVE_LABERER_REPORT,
    helperId: '2088',
  },
  {
    route: RouteUrls.TERMINATED_LABELER_REPORT,
    helperId: '2123',
  },
  {
    route: RouteUrls.MONTHLY_CLAIMS_RECONCILIATION_REPORT,
    helperId: '2105',
  },
  {
    route: RouteUrls.QUARTERLY_CLAIMS_RECONCILIATION_REPORT,
    helperId: '2115',
  },
  {
    route: RouteUrls.DRUG_THERAPEUTIC_CLASS_REPORT,
    helperId: '2096',
  },
  {
    route: RouteUrls.SUPPLEMENTAL_RATES_REPORT,
    helperId: '2121',
  },
  {
    route: RouteUrls.UNIT_ADJUSTMENTS_AT_NDC_LEVEL_REPORT,
    helperId: '2125',
  },
  {
    route: RouteUrls.SUBSTANCE_ABUSE_DRUG_REPORT,
    helperId: '2120',
  },
  {
    route: RouteUrls.RIDER_REPORT,
    helperId: '2119',
  },
  {
    route: RouteUrls.CMS_QUARTERLY_REPORT,
    helperId: '2022',
  },

  //Display Summary Report
  {
    route: RouteUrls.DISPLAY_PAYMENT_SUMMARY_REPORT,
    helperId: '2134',
  },
  {
    route: RouteUrls.DISPLAY_REBATE_PERCENT_SPEND_REPORT,
    helperId: '2135',
  },
  {
    route: RouteUrls.DISPLAY_INVOICE_REGISTER_REPORT,
    helperId: '2133',
  },
  {
    route: RouteUrls.DISPLAY_QUARTERLY_PAYMENT_REPORT,
    helperId: '2136',
  },
  {
    route: RouteUrls.DISPLAY_INVOICE_QTR_NOT_PAID_REPORT,
    helperId: '2132',
  },
  {
    route: RouteUrls.DISPLAY_TOP_BALANCE_REPORT,
    helperId: '2138',
  },
  {
    route: RouteUrls.DISPLAY_DRUG_TYPE_SUMMARY_REPORT,
    helperId: '2131',
  },
  {
    route: RouteUrls.DISPLAY_DISPUTE_AMOUNT_REPORT,
    helperId: '2128',
  },
  {
    route: RouteUrls.DISPLAY_DISPUTE_ACTIVITY_REPORT,
    helperId: '2127',
  },
  {
    route: RouteUrls.DISPLAY_DISPUTE_CODE_REPORT,
    helperId: '2129',
  },

  //Display Detail Reports
  {
    route: RouteUrls.DISPLAY_UNALLOCATED_BALANCE_REPORT,
    helperId: '2038',
  },
  {
    route: RouteUrls.DISPLAY_CHECK_ALLOCATION_COMPARISION_REPORT,
    helperId: '2025',
  },
  {
    route: RouteUrls.DISPLAY_CURRENT_ZERO_URA_REPORT,
    helperId: '2027',
  },
  {
    route: RouteUrls.DISPLAY_NDC_DETAILS_REPORT,
    helperId: '2034',
  },
  {
    route: RouteUrls.DISPLAY_NDC_HISTORY_REPORT,
    helperId: '2035',
  },
  {
    route: RouteUrls.DISPLAY_DISPUTE_RECAPITULATION_REPORT,
    helperId: '2028',
  },
  {
    route: RouteUrls.DISPLAY_HCPCS_CODE_CLAIMS_PAID_REPORT,
    helperId: '2029',
  },
  {
    route: RouteUrls.DISPLAY_INTEREST_OVERRIDE_REPORT,
    helperId: '2030',
  },
  {
    route: RouteUrls.DISPLAY_ROSI_PQAS_REPORT,
    helperId: '2037',
  },
  {
    route: RouteUrls.DISPLAY_MANUFACTURER_SUMMARY_REPORT,
    helperId: '2031',
  },
  {
    route: RouteUrls.DISPLAY_ADJUSTED_CLAIMS_REPORT,
    helperId: '2024',
  },
  {
    route: RouteUrls.DISPLAY_MCO_CLAIMS_REPORT,
    helperId: '2032',
  },
  {
    route: RouteUrls.DISPLAY_PROVIDER_CLAIMS_LISTING_REPORT,
    helperId: '2036',
  },

  //Display State Report
  {
    route: RouteUrls.DISPLAY_EXCLUDED_CLAIMS_REPORT,
    helperId: '2098',
  },
  {
    route: RouteUrls.DISPLAY_CHIP_CSHCN_RATES_REPORT,
    helperId: '2091',
  },
  {
    route: RouteUrls.DISPLAY_CHIP_CSHCN_RATES_AUDIT_REPORT,
    helperId: '2092',
  },
  {
    route: RouteUrls.DISPLAY_ZERO_URA_REPORT,
    helperId: '2126',
  },
  {
    route: RouteUrls.DISPLAY_INTEREST_RECEIVED_REPORT,
    helperId: '2102',
  },
  {
    route: RouteUrls.DISPLAY_OUTSTANDING_DISPUTES_AFTER_NUM_OF_DAYS_REPORT,
    helperId: '2108',
  },
  {
    route: RouteUrls.DISPLAY_OUTSTANDING_DISPUTES_FOR_QUARTER_REPORT,
    helperId: '2109',
  },
  {
    route: RouteUrls.DISPLAY_ADJUSTMENT_BY_REASON_CODE_REPORT,
    helperId: '2089',
  },
  {
    route: RouteUrls.DISPLAY_QUARTERLY_CMS_UROA_REPORT,
    helperId: '2117',
  },
  {
    route: RouteUrls.DISPLAY_INSTITUTIONAL_CLAIMS_UNIT_TYPE_DISCREPANCY_REPORT,
    helperId: '2101',
  },
  {
    route: RouteUrls.DISPLAY_QUARTERLY_CMS_DRUG_REPORT,
    helperId: '2116',
  },
  {
    route: RouteUrls.DISPLAY_B_PROVIDER_CLAIMS_REPORT,
    helperId: '2087',
  },
  {
    route: RouteUrls.DISPLAY_PROGRAM_ELIGIBILITY_CATEGORY_REPORT,
    helperId: '2114',
  },
  {
    route: RouteUrls.DISPLAY_PRE_INVOICE_UNIT_ADJUSTMENT_REPORT,
    helperId: '2113',
  },
  {
    route: RouteUrls.DISPLAY_CURRENT_TO_PREVIOUS_QTR_INVOICE_COMPARIRION_REPORT,
    helperId: '2094',
  },
  {
    route: RouteUrls.DISPLAY_CASH_RECEIPT_SUMMARY_REPORT,
    helperId: '2090',
  },
  {
    route: RouteUrls.DISPLAY_CMS_ADJUSTMENT_DETAIL_REPORT,
    helperId: '2093',
  },
  {
    route: RouteUrls.DISPLAY_OUTSTANDING_BALANCE_BY_LABERER_AND_QUARTER_REPORT,
    helperId: '2107',
  },
  {
    route: RouteUrls.DISPLAY_MANUFACTURER_OUTSTANDING_BALANCE_REPORT,
    helperId: '2104',
  },
  {
    route: RouteUrls.DISPLAY_NDC_PAYMENT_REPORT,
    helperId: '2106',
  },
  {
    route: RouteUrls.DISPLAY_FAMILY_PLANNING_DRUG_INVOICED_REBATES_REPORT,
    helperId: '2099',
  },
  {
    route: RouteUrls.DISPLAY_FAMILY_PLANNING_DRUGS_PAYMENT_RECEIVED_REPORT,
    helperId: '2100',
  },
  {
    route: RouteUrls.DISPLAY_ACTIVE_LABERER_REPORT,
    helperId: '2088',
  },
  {
    route: RouteUrls.DISPLAY_TERMINATED_LABELER_REPORT,
    helperId: '2123',
  },
  {
    route: RouteUrls.DISPLAY_MONTHLY_CLAIMS_RECONCILIATION_REPORT,
    helperId: '2105',
  },
  {
    route: RouteUrls.DISPLAY_QUARTERLY_CLAIMS_RECONCILIATION_REPORT,
    helperId: '2115',
  },
  {
    route: RouteUrls.DISPLAY_DRUG_THERAPEUTIC_CLASS_REPORT,
    helperId: '2096',
  },
  {
    route: RouteUrls.DISPLAY_SUPPLEMENTAL_RATES_REPORT,
    helperId: '2121',
  },
  {
    route: RouteUrls.DISPLAY_UNIT_ADJUSTMENTS_AT_NDC_LEVEL_REPORT,
    helperId: '2125',
  },
  {
    route: RouteUrls.DISPLAY_SUBSTANCE_ABUSE_DRUG_REPORT,
    helperId: '2120',
  },
  {
    route: RouteUrls.DISPLAY_RIDER_REPORT,
    helperId: '2119',
  },
  {
    route: RouteUrls.DISPLAY_CMS_QUARTERLY_REPORT,
    helperId: '2022',
  },
  {
    route: RouteUrls.UNITS_CLAIM,
    helperId: '2067',
  },
  {
    route: RouteUrls.UNITS_SELECTED_CLAIM,
    helperId: '2067',
  },
  {
    route: RouteUrls.REMINDER,
    helperId: '2149',
  },
   {
    route: RouteUrls.RECEIPT,
    helperId: '2148',
  },
    {
    route: RouteUrls.SYSTEM_REMINDER,
    helperId: '2153 ',
  },
    {
    route: RouteUrls.DATA_NICHE,
    helperId: '2158 ',
  }
];

export default routeHelpTabConfig;
